import React, { useContext } from 'react';
import FixedImg from "../../../../Assets/Images/Fixed.png";
import GrowthImg from "../../../../Assets/Images/Growth.png";
import GroupReportContext from '../../../../Context/GroupReportContext';
import { to1Decimal, getMindsetSum } from '../../../../utils/helper';

const segments = [
  { name: 'Rigid\nSelf-Definition', color: '#00577D' },
  { name: 'Cautious\nOpenness', color: '#3896B4' },
  { name: 'Conditional\nGrowth', color: '#FFDE59' },
  { name: 'Adaptive\nLearner', color: '#7ED957' },
  { name: 'Transformative\nGrowth', color: '#246C21' }
];

const mindsetBoxPosition = (segmentIndex, percentage) => {
  if (segmentIndex == 0 && percentage >= 0 && percentage < 16) {
    return true;
  }
  else if (segmentIndex == 1 && percentage >= 16 && percentage < 36) {
    return true;
  }
  else if (segmentIndex == 2 && percentage >= 36 && percentage < 66) {
    return true;
  }
  else if (segmentIndex == 3 && percentage >= 66 && percentage < 86) {
    return true;
  }
  else if (segmentIndex == 4 && percentage >= 86 && percentage <= 100) {
    return true;
  }
  else {
    return false;
  }
}

const SelfMindsetResultImg = ({ variables }) => {

  const { getPercentileFromScore } = useContext(GroupReportContext);

  // Calculate mindset sum from variables array using helper function
  const mindsetSum = getMindsetSum(variables);

  const percentage = to1Decimal(getPercentileFromScore(mindsetSum))
  const segmentIndex = Math.min(Math.floor((percentage / 100) * segments.length), segments.length - 1);

  return (
    <div style={{ width: '468px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', position: 'relative' }}>
   
      <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', width: '100%', position: 'relative', height: '96px', }}>

        {/* Fixed Icon & Label */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '10px', position: 'relative', paddingBottom: '35px' }}>
          <img src={FixedImg} alt="Fixed" style={{ width: '39px', height: '39px', marginBottom: '4px', borderRadius: '70px' }} />
          <div style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 700, fontSize: '10px', lineHeight: '14px', textAlign: 'center', color: '#5E5E5E', letterSpacing: '0px' }}>
            Fixed
          </div>
        </div>

        {/* Progress bar section */}
        <div style={{ flexGrow: 1, position: 'relative', height: "60px",}}>

          {/* Score bubble */}
          <div style={{ position: 'absolute', top: '-35px', left: 0, right: 0, display: 'flex', justifyContent: 'space-between', height: '50px', zIndex: 2 }}>
            {segments.map((_, idx) => (
              <div key={idx} style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'flex-end'
              }}>
                {mindsetBoxPosition(idx, Math.round(percentage)) && (
                  <div style={{ width: '51.49px', height: '40.41px', backgroundColor: '#245775', color: '#FFFFFF', borderRadius: '8px', fontFamily: 'Helvetica, sans-serif', fontWeight: 700, fontSize: '20px', lineHeight: '27px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', transform: 'translateX(-50%)', marginLeft: '50%', padding: "0 6px" }}>
                    {percentage}%
                    {/* Arrow pointing down */}
                    <div style={{ width: '0', height: '0', borderLeft: '8px solid transparent', borderRight: '8px solid transparent', borderTop: '8px solid #245775', position: 'absolute', bottom: '-8px', left: '50%', transform: 'translateX(-50%)' }} />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Progress segments with gaps */}
          <div style={{ display: 'flex', height: '20px', borderRadius: '10px', overflow: 'hidden', gap: '2px', marginTop: '15px' }}>
            {segments.map((seg, idx) => (
              <div
                key={idx}
                style={{
                  flex: 1,
                  backgroundColor: seg.color,
                  borderTopLeftRadius: idx === 0 ? '10px' : '0',
                  borderBottomLeftRadius: idx === 0 ? '10px' : '0',
                  borderTopRightRadius: idx === segments.length - 1 ? '10px' : '0',
                  borderBottomRightRadius: idx === segments.length - 1 ? '10px' : '0'
                }}
              />
            ))}
          </div>

          {/* Segment labels */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', paddingLeft: '5px', paddingRight: '5px' }}>
            {segments.map((seg, idx) => (
              <div
                key={idx}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  fontSize: "10px",
                  lineHeight: "14px",
                  fontFamily: "Helvetica",
                  color: "#5E5E5E",
                  fontWeight: mindsetBoxPosition(idx, Math.round(percentage)) ? "700" : "400",
                  whiteSpace: 'pre-line',
                  letterSpacing: '0px'
                }} >
                {seg.name}
              </div>
            ))}
          </div>
        </div>

        {/* Growth Icon & Label */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '10px', position: 'relative', paddingBottom: '35px' }}>
          <img src={GrowthImg} alt="Growth" style={{ width: '39px', height: '39px', marginBottom: '4px', borderRadius: '70px' }} />
          <div style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 700, fontSize: '10px', lineHeight: '14px', textAlign: 'center', color: '#5E5E5E', letterSpacing: '0px' }}>
            Growth
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfMindsetResultImg;
